<template>
    <div>
        <h1 class="my-5">{{ mainTitle }}</h1>

        <b-form>
            <div class="mb-5">
                <h2 class="mb-5"><b>Packs</b> "Création d'entreprise"</h2>

                <b-row v-if="services.creation.company.legalForm !== 'Auto-Entrepreneur / Micro-entreprise'">
                    <b-col cols="12" lg="4" class="mb-5"
                    v-for="(pack, index) in services.creation.packs"
                    :key="index">
                        <OptionRadio
                        :index="index"
                        :pack="pack"
                        :legalForm="services.creation.company.legalForm"
                        @radioChange="commitPack" />
                    </b-col>
                </b-row>

                <OptionRadio
                v-else
                :index="0"
                :pack="services.creation.packs[0]"
                :legalForm="services.creation.company.legalForm"
                @radioChange="commitPack" />
            </div>

            <OptionCheckbox
            v-for="(option, index) in services.creation.options"
            :key="index"
            :index="index"
            :option="option"
            @checkboxChange="commitOptions" />
        </b-form>
  </div>
</template>

<script>
    import { mapState } from 'vuex'

    import OptionCheckbox from '../OptionCheckbox.vue'
    import OptionRadio from '../OptionRadio.vue'

    export default {
        components: {
            OptionCheckbox,
            OptionRadio
        },
        data() {
            return {
                mainTitle: "Choisissez vos options",
            };
        },
        methods: {
            commitOptions(lastOptionClicked) {
                this.$store.commit('updateCreationOptions', { lastOptionClicked: lastOptionClicked })
            },
            commitPack(activePack) {
                this.$store.commit('updateCreationPack', { activePack: activePack })
            }
        },
        computed: {
            ...mapState(['services'])
        }
    };
</script>
